import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTags } from "../../features/tags/tagsSlice";
import ResetFilter from "./ResetFilter";
import SelectLimit from "./SelectLimit";
import Tag from "./Tag";

export default function Tags() {
  const { tags } = useSelector((state) => state.tags);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTags());
  }, [dispatch]);

  return (
    <section>
      <div className="max-w-7xl mx-auto px-5 py-3 lg:px-0 border-b md:flex gap-2 items-end">
        {tags?.length > 0 ? (
          <div className="w-full mx-auto flex gap-2 overflow-y-auto py-2 tagsScrollbar">
            {tags.map((tag) => (
              <Tag key={tag.id} title={tag.title} />
            ))}
          </div>
        ) : null}
        <div className="flex gap-2 items-center justify-start mt-2 md:mt-0">
          <SelectLimit />
          <ResetFilter />
        </div>
      </div>
    </section>
  );
}
